var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-list"},[_c('ul',{staticClass:"u-reset blog-list__items"},_vm._l((_vm.articles),function(ref){
var publish_date = ref.publish_date;
var slug = ref.slug;
var title = ref.title;
return _c('li',{key:slug,staticClass:"blog-list__item"},[_c('n-link',{staticClass:"u-reset blog-list__link",attrs:{"to":_vm.getLink(slug)}},[_vm._v("\n        "+_vm._s(title)+" /\n        "),_c('time',{attrs:{"datetime":publish_date}},[_vm._v(_vm._s(_vm.getDate(publish_date)))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }